<template>
  <div class="mod-overlay" @click.self="$emit('close')">
    <div class="mod-modal form-modal-wide">
      <!-- Header -->
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i :class="modalIcon"></i>
          {{ modalTitle }}
        </h3>
        <button class="mod-modal-close" @click="$emit('close')">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <!-- Body -->
      <form @submit.prevent="handleSubmit" class="mod-modal-body">
        <!-- Error -->
        <div v-if="error" class="mod-alert-error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          {{ error }}
        </div>

        <!-- === IDENTIFICACIÓN === -->
        <div class="form-section">
          <div class="form-section-hdr">
            <i class="bi bi-person-badge"></i>
            Identificación
          </div>
          <div class="form-g3">
            <div class="mod-field">
              <label for="Clave">Clave <span class="mod-required">*</span></label>
              <input
                type="text"
                id="Clave"
                v-model="form.Clave"
                :disabled="isEdit || claveAutomatica"
                :required="!claveAutomatica"
                maxlength="50"
                :placeholder="claveAutomatica ? 'Automática' : 'Código del socio'"
                :class="{ error: errors.Clave }"
              >
              <span v-if="errors.Clave" class="mod-field-error-msg">{{ errors.Clave }}</span>
            </div>
            <div class="mod-field">
              <label for="TipoSocio">{{ isConversion ? 'Convertir en' : 'Tipo de Socio' }} <span class="mod-required">*</span></label>
              <select id="TipoSocio" v-model="form.TipoSocio" required @change="onTipoSocioChange" :class="{ error: errors.TipoSocio }">
                <option value="">Seleccionar...</option>
                <option
                  v-for="tipo in tiposSocioDisponibles"
                  :key="tipo.Clave"
                  :value="tipo.Clave"
                >
                  {{ tipo.Clave }} - {{ tipo.Nombre }}
                </option>
              </select>
              <span v-if="errors.TipoSocio" class="mod-field-error-msg">{{ errors.TipoSocio }}</span>
            </div>
            <div class="mod-field mod-field-check form-check-end">
              <label class="mod-check-label">
                <input type="checkbox" v-model="form.EsActivo">
                <span>Activo</span>
              </label>
            </div>
          </div>
          <div class="form-g2">
            <div class="mod-field">
              <label for="NombreComercial">Nombre Comercial <span class="mod-required">*</span></label>
              <input type="text" id="NombreComercial" v-model="form.NombreComercial" required maxlength="255" placeholder="Nombre comercial" :class="{ error: errors.NombreComercial }">
              <span v-if="errors.NombreComercial" class="mod-field-error-msg">{{ errors.NombreComercial }}</span>
            </div>
            <div class="mod-field">
              <label for="RazonSocial">Razón Social <span class="mod-required">*</span></label>
              <input type="text" id="RazonSocial" v-model="form.RazonSocial" required maxlength="255" placeholder="Razón social" :class="{ error: errors.RazonSocial }">
              <span v-if="errors.RazonSocial" class="mod-field-error-msg">{{ errors.RazonSocial }}</span>
            </div>
          </div>
        </div>

        <!-- === DATOS FISCALES === -->
        <div class="form-section">
          <div class="form-section-hdr">
            <i class="bi bi-receipt"></i>
            Datos Fiscales
          </div>
          <div class="form-g3">
            <div class="mod-field">
              <label for="RFC">RFC <span class="mod-required">*</span></label>
              <input type="text" id="RFC" v-model="form.RFC" required maxlength="13" placeholder="RFC" :class="{ error: errors.RFC }">
              <span v-if="errors.RFC" class="mod-field-error-msg">{{ errors.RFC }}</span>
            </div>
            <div class="mod-field">
              <label for="Curp">CURP</label>
              <input type="text" id="Curp" v-model="form.Curp" maxlength="18" placeholder="CURP">
            </div>
            <div class="mod-field">
              <label for="RegimenFiscal">Régimen Fiscal</label>
              <input type="text" id="RegimenFiscal" v-model="form.RegimenFiscal" maxlength="10" placeholder="Régimen fiscal">
            </div>
          </div>
        </div>

        <!-- === DIRECCIÓN === -->
        <div class="form-section">
          <div class="form-section-hdr">
            <i class="bi bi-geo-alt"></i>
            Dirección
          </div>
          <div class="form-g-addr">
            <div class="mod-field">
              <label for="Calle">Calle</label>
              <input type="text" id="Calle" v-model="form.Calle" maxlength="255" placeholder="Calle">
            </div>
            <div class="mod-field">
              <label for="NumExt">Núm. Ext.</label>
              <input type="text" id="NumExt" v-model="form.NumExt" maxlength="50" placeholder="Ext.">
            </div>
            <div class="mod-field">
              <label for="NumInt">Núm. Int.</label>
              <input type="text" id="NumInt" v-model="form.NumInt" maxlength="50" placeholder="Int.">
            </div>
          </div>
          <div class="form-g5">
            <div class="mod-field">
              <label for="Colonia">Colonia</label>
              <input type="text" id="Colonia" v-model="form.Colonia" maxlength="100" placeholder="Colonia">
            </div>
            <div class="mod-field">
              <label for="CP">C.P.</label>
              <input type="text" id="CP" v-model="form.CP" maxlength="10" placeholder="C.P.">
            </div>
            <div class="mod-field">
              <label for="Municipio">Municipio</label>
              <input type="text" id="Municipio" v-model="form.Municipio" maxlength="100" placeholder="Municipio">
            </div>
            <div class="mod-field">
              <label for="Estado">Estado</label>
              <input type="text" id="Estado" v-model="form.Estado" maxlength="100" placeholder="Estado">
            </div>
            <div class="mod-field">
              <label for="Pais">País</label>
              <input type="text" id="Pais" v-model="form.Pais" maxlength="50" placeholder="País">
            </div>
          </div>
        </div>

        <!-- === CONTACTO === -->
        <div class="form-section">
          <div class="form-section-hdr">
            <i class="bi bi-telephone"></i>
            Contacto
          </div>
          <div class="form-g3">
            <div class="mod-field">
              <label for="Telefono1">Teléfono 1</label>
              <input type="text" id="Telefono1" v-model="form.Telefono1" maxlength="50" placeholder="Teléfono principal">
            </div>
            <div class="mod-field">
              <label for="Telefono2">Teléfono 2</label>
              <input type="text" id="Telefono2" v-model="form.Telefono2" maxlength="50" placeholder="Teléfono alterno">
            </div>
            <div class="mod-field">
              <label for="Email">Email</label>
              <input type="text" id="Email" v-model="form.Email" maxlength="255" placeholder="Correo electrónico">
            </div>
          </div>
          <div class="form-g4">
            <div class="mod-field form-span-2">
              <label for="ContactoNombre1">Nombre del Contacto</label>
              <input type="text" id="ContactoNombre1" v-model="form.ContactoNombre1" maxlength="255" placeholder="Nombre del contacto">
            </div>
            <div class="mod-field">
              <label for="ContactoPuesto1">Puesto</label>
              <input type="text" id="ContactoPuesto1" v-model="form.ContactoPuesto1" maxlength="100" placeholder="Puesto">
            </div>
            <div class="mod-field">
              <label for="ContactoTelefono1">Tel. del Contacto</label>
              <input type="text" id="ContactoTelefono1" v-model="form.ContactoTelefono1" maxlength="50" placeholder="Teléfono del contacto">
            </div>
          </div>
          <div class="form-g2">
            <div class="mod-field">
              <label for="ContactoEmail1">Email del Contacto</label>
              <input type="text" id="ContactoEmail1" v-model="form.ContactoEmail1" maxlength="255" placeholder="Email del contacto">
            </div>
          </div>
        </div>

        <!-- === FACTURACIÓN POR DEFECTO === -->
        <div class="form-section">
          <div class="form-section-hdr">
            <i class="bi bi-file-earmark-text"></i>
            Facturación por Defecto
          </div>
          <div class="form-g4">
            <div class="mod-field">
              <label for="MonedaDefault">Moneda</label>
              <input type="text" id="MonedaDefault" v-model="form.MonedaDefault" maxlength="5" placeholder="MXN, USD...">
            </div>
            <div class="mod-field">
              <label for="MetodoPagoDefault">Método de Pago</label>
              <input type="text" id="MetodoPagoDefault" v-model="form.MetodoPagoDefault" maxlength="50" placeholder="PUE, PPD...">
            </div>
            <div class="mod-field">
              <label for="FormaPagoDefault">Forma de Pago</label>
              <input type="text" id="FormaPagoDefault" v-model="form.FormaPagoDefault" maxlength="50" placeholder="03, 99...">
            </div>
            <div class="mod-field">
              <label for="UsoCFDIDefault">Uso CFDI</label>
              <input type="text" id="UsoCFDIDefault" v-model="form.UsoCFDIDefault" maxlength="10" placeholder="G03, P01...">
            </div>
          </div>
        </div>

        <!-- === CRÉDITO === -->
        <div class="form-section">
          <div class="form-section-hdr">
            <i class="bi bi-cash-stack"></i>
            Crédito
          </div>
          <div class="form-g3">
            <div class="mod-field">
              <label for="DiasCredito">Días de Crédito</label>
              <input type="number" id="DiasCredito" v-model.number="form.DiasCredito" min="0">
            </div>
            <div class="mod-field">
              <label for="LimiteCredito">Límite de Crédito</label>
              <input type="number" id="LimiteCredito" v-model.number="form.LimiteCredito" step="0.01" min="0">
            </div>
            <div class="mod-field">
              <label for="SaldoActual">Saldo Actual</label>
              <input type="number" id="SaldoActual" v-model.number="form.SaldoActual" step="0.01">
            </div>
          </div>
        </div>

        <!-- === OTROS === -->
        <div class="form-section">
          <div class="form-section-hdr">
            <i class="bi bi-three-dots"></i>
            Otros
          </div>
          <div class="form-g2">
            <div class="mod-field">
              <label for="ClaveErp">Clave ERP</label>
              <input type="text" id="ClaveErp" v-model="form.ClaveErp" maxlength="50" placeholder="Mapeo con sistema ERP">
            </div>
          </div>
          <div class="mod-field">
            <label for="Notas">Notas</label>
            <textarea id="Notas" v-model="form.Notas" rows="2" placeholder="Notas adicionales"></textarea>
          </div>
        </div>

        <!-- Footer -->
        <div class="mod-modal-footer">
          <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">Cancelar</button>
          <button type="submit" class="mod-btn mod-btn-save" :disabled="saving">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else>
              <i class="bi bi-check-lg"></i>
              {{ submitLabel }}
            </template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import socionegocioService from './socionegocio.service';
import { showToast } from '@/shared/utils/toast';
import authService from '@/services/auth';
import catalogosViewService from '@/shared/services/catalogosView.service';
import parametroService from '@/modules/parametros/parametro.service';
import { createSocioNegocio } from './socionegocio.model';

const PARAM_SOCIO_CLAVE_MODO = 'SOCIO_CLAVE_MODO';
const MODO_CLAVE_AUTOMATICA = 'AUTOMATICA';
const MODO_CLAVE_MANUAL = 'MANUAL';

const TIPOS_SOCIO_DEFAULT = [
  { Clave: 'C', Nombre: 'Cliente' },
  { Clave: 'P', Nombre: 'Proveedor' },
  { Clave: 'X', Nombre: 'Prospecto' },
  { Clave: 'E', Nombre: 'Empleado' },
  { Clave: 'A', Nombre: 'Alumno / Estudiante' }
];

export default {
  name: 'SocioNegocioForm',
  props: {
    item: { type: Object, default: null },
    isEdit: { type: Boolean, default: false },
    isConversion: { type: Boolean, default: false }
  },
  emits: ['saved', 'close'],
  data() {
    return {
      form: createSocioNegocio(),
      tiposSocio: TIPOS_SOCIO_DEFAULT,
      modoClaveSocio: MODO_CLAVE_AUTOMATICA,
      saving: false,
      error: null,
      errors: {}
    };
  },
  computed: {
    claveAutomatica() {
      return !this.isEdit && this.modoClaveSocio === MODO_CLAVE_AUTOMATICA;
    },
    tiposSocioDisponibles() {
      if (!this.isConversion) return this.tiposSocio;
      const tipoActual = String(this.item?.TipoSocio || '').toUpperCase();
      return this.tiposSocio.filter(tipo => String(tipo.Clave || '').toUpperCase() !== tipoActual);
    },
    modalIcon() {
      if (this.isConversion) return 'bi bi-arrow-left-right';
      return this.isEdit ? 'bi bi-pencil' : 'bi bi-plus-circle';
    },
    modalTitle() {
      if (this.isConversion) {
        const labels = { C: 'Cliente', P: 'Proveedor', X: 'Prospecto', E: 'Empleado', A: 'Alumno' };
        const tipo = labels[String(this.item?.TipoSocio || '').toUpperCase()] || 'Socio';
        return `Convertir ${tipo}`;
      }
      return this.isEdit ? 'Editar socio de negocio' : 'Nuevo socio de negocio';
    },
    submitLabel() {
      if (this.isConversion) return 'Crear copia';
      return this.isEdit ? 'Guardar cambios' : 'Crear socio';
    }
  },
  async created() {
    await Promise.all([this.loadTiposSocio(), this.loadModoClaveSocio()]);
    if (this.isEdit && this.item) {
      this.form = { ...this.item };
    } else if (this.isConversion && this.item) {
      const empresa = authService.getSelectedEmpresa();
      this.form = {
        ...createSocioNegocio(),
        ...this.item,
        EmpresaId: empresa?.EmpresaId || this.item.EmpresaId || 0,
        Clave: '',
        TipoSocio: this.getTipoConversionDefault(),
        EsActivo: true
      };
      if (this.claveAutomatica) await this.previewSiguienteClave();
    } else {
      const empresa = authService.getSelectedEmpresa();
      this.form.EmpresaId = empresa?.EmpresaId || 0;
      this.form.TipoSocio = this.form.TipoSocio || 'C';
      if (this.claveAutomatica) await this.previewSiguienteClave();
    }
  },
  methods: {
    async loadModoClaveSocio() {
      const empresa = authService.getSelectedEmpresa();
      const empresaId = empresa?.EmpresaId || 0;
      try {
        const parametro = await parametroService.leer({
          Clave: PARAM_SOCIO_CLAVE_MODO,
          EmpresaId: empresaId
        });
        const valor = String(parametro?.Valor || MODO_CLAVE_AUTOMATICA).trim().toUpperCase();
        this.modoClaveSocio = valor === MODO_CLAVE_MANUAL ? MODO_CLAVE_MANUAL : MODO_CLAVE_AUTOMATICA;
      } catch {
        this.modoClaveSocio = MODO_CLAVE_AUTOMATICA;
      }
    },
    async loadTiposSocio() {
      try {
        const cats = await catalogosViewService.leerVarios('socionegocio_tipo');
        const items = Array.isArray(cats?.socionegocio_tipo) ? cats.socionegocio_tipo : [];
        this.tiposSocio = items.length ? items : TIPOS_SOCIO_DEFAULT;
      } catch {
        this.tiposSocio = TIPOS_SOCIO_DEFAULT;
      }
    },
    getTipoConversionDefault() {
      const primerTipo = this.tiposSocioDisponibles[0];
      return primerTipo?.Clave || 'C';
    },
    async onTipoSocioChange() {
      if (this.claveAutomatica) await this.previewSiguienteClave();
    },
    async previewSiguienteClave() {
      try {
        const data = await socionegocioService.siguienteClave(this.form.TipoSocio || 'C');
        this.form.Clave = data?.Clave || '';
      } catch {
        this.form.Clave = '';
      }
    },
    validateForm() {
      const errs = {};
      const val = f => String(this.form[f] || '').trim();

      if (!this.claveAutomatica && !val('Clave'))
        errs.Clave = 'La clave es obligatoria';
      if (!val('TipoSocio'))
        errs.TipoSocio = 'Selecciona un tipo de socio';
      if (!val('NombreComercial'))
        errs.NombreComercial = 'El nombre comercial es obligatorio';
      if (!val('RazonSocial'))
        errs.RazonSocial = 'La razón social es obligatoria';
      if (!val('RFC'))
        errs.RFC = 'El RFC es obligatorio';

      return errs;
    },
    async handleSubmit() {
      this.errors = this.validateForm();
      if (Object.keys(this.errors).length) {
        this.error = 'Revisa los campos marcados en rojo';
        return;
      }

      this.saving = true;
      this.error = null;

      try {
        const payload = {
          ...this.form,
          Clave: this.claveAutomatica ? '' : this.form.Clave
        };
        const result = await socionegocioService.guardar(payload);
        if (result.Number >= 0) {
          showToast(result.Message || 'Guardado correctamente', result.Type || 'success');
          this.$emit('saved');
        } else {
          this.error = result.Message || 'Error al guardar';
        }
      } catch (e) {
        console.error('Error al guardar:', e);
        this.error = 'Error de conexion con el servidor';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";

/* ── Modal ampliado ─────────────────────────────────── */
.form-modal-wide {
  max-width: 880px;
}

/* ── Secciones ──────────────────────────────────────── */
.form-section {
  border: 1px solid #e8eef5;
  border-radius: 8px;
  padding: 0.875rem 1rem 1rem;
  background: #ffffff;
  margin-bottom: 0.75rem;
}

.form-section:last-of-type {
  margin-bottom: 0;
}

.form-section-hdr {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--t-primary, #1272c4);
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 0.875rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #edf2f7;
}

.form-section-hdr i {
  font-size: 0.8rem;
}

/* ── Grid layouts ───────────────────────────────────── */
.form-g2,
.form-g3,
.form-g4,
.form-g5,
.form-g-addr {
  display: grid;
  gap: 0.75rem 1rem;
  margin-bottom: 0.75rem;
}

.form-g2     { grid-template-columns: repeat(2, 1fr); }
.form-g3     { grid-template-columns: repeat(3, 1fr); }
.form-g4     { grid-template-columns: repeat(4, 1fr); }
.form-g5     { grid-template-columns: repeat(5, 1fr); }
.form-g-addr { grid-template-columns: 3fr 1fr 1fr; }

.form-g2:last-child,
.form-g3:last-child,
.form-g4:last-child,
.form-g5:last-child,
.form-g-addr:last-child {
  margin-bottom: 0;
}

.form-span-2 { grid-column: span 2; }

/* Alineación inferior para el checkbox de Activo */
.form-check-end {
  align-self: end;
  padding-bottom: 0.45rem;
}

/* ── Textarea ───────────────────────────────────────── */
.mod-field textarea {
  width: 100%;
  padding: 0.6rem 0.85rem;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.9rem;
  font-family: inherit;
  color: #2d3748;
  background: #ffffff;
  resize: vertical;
  transition: border-color 0.2s;
}

.mod-field textarea:focus {
  outline: none;
  border-color: var(--t-border-focus, #1272c4);
  box-shadow: 0 0 0 3px var(--t-primary-ring, rgba(18, 114, 196, 0.1));
}

/* ── Validación ─────────────────────────────────────── */
.mod-field input.error,
.mod-field select.error {
  border-color: #e53e3e;
}

.mod-field-error-msg {
  display: block;
  font-size: 0.72rem;
  color: #e53e3e;
  margin-top: 0.2rem;
}

/* ── Responsive ─────────────────────────────────────── */
@media (max-width: 720px) {
  .form-g3,
  .form-g4,
  .form-g5,
  .form-g-addr {
    grid-template-columns: repeat(2, 1fr);
  }

  .form-span-2 {
    grid-column: span 1;
  }
}

@media (max-width: 480px) {
  .form-g2,
  .form-g3,
  .form-g4,
  .form-g5,
  .form-g-addr {
    grid-template-columns: 1fr;
  }
}
</style>
